interface IProps {
    item: any
}
const HelpVideo = (props:IProps) : JSX.Element =>
{
    switch(props.item.type) {
        case "youtube":
            return <div className='flex-centered w-100 h-100'> 
                <iframe 
                    width="800" 
                    height="450" 
                    src={ `https://www.youtube.com/embed/${ props.item.id }?autoplay=1` }
                    title={ props.item.title }  
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                    allowFullScreen>

                </iframe>
            </div> 
        case "vk_video":
             return <div className='flex-centered w-100 h-100'> 
                <iframe 
                    width="800" 
                    height="450" 
                    src={ `${ props.item.id }&autoplay=1` }
                    title={ props.item.title }  
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                    allowFullScreen>

                </iframe>
            </div> 
        default: 
            return <div className='flex-centered w-100 h-100' dangerouslySetInnerHTML={{__html:  props.item.id}}>  
            </div>  
    }
    
}

export default HelpVideo